import { dropdownItems } from "src/app/services/util.service";

export const MESES: dropdownItems[] = [
  { label: "TODOS", value: "" },
  { label: "ENERO", value: "01" },
  { label: "FEBRERO", value: "02" },
  { label: "MARZO", value: "03" },
  { label: "ABRIL", value: "04" },
  { label: "MAYO", value: "05" },
  { label: "JUNIO", value: "06" },
  { label: "JULIO", value: "07" },
  { label: "AGOSTO", value: "08" },
  { label: "SEPTIEMBRE", value: "09" },
  { label: "OCTUBRE", value: "10" },
  { label: "NOVIEMBRE", value: "11" },
  { label: "DICIEMBRE", value: "12" }
]

export const REGIMEN: dropdownItems[] = [
  { label: "IMPORTACIONES", value: "001" },
  { label: "EXPORTACIONES", value: "002" }
]

export const FUNC_ENTIDAD = {
  cliente: 1,
  proveedor: 2,
  ejecutivo: 3,
  customer: 4,
  transportista: 5,
  agente: 6,
  broker: 7,
  agente_carga: 8,
  contacto: 9,
  shipper: 10,
  agente_portuario: 11,
  agencia_aduanera: 12,
  agencia_maritima: 13,
  deposito_temporal: 14,
  deposito_vacio: 15,
  empleado: 16,
  terminal_portuario: 17,
  agente_reembolso: 18,
  coloader: 19
}

export const FUNCION_ENTIDAD = [
  { label: "Cliente", value: 1 },
  { label: "Proveedor", value: 2 },
  { label: "Ejecutivos de Venta", value: 3 },
  { label: "Customer Services", value: 4 },
  { label: "Transportista", value: 5 },
  { label: "Agente", value: 6 },
  { label: "Broker", value: 7 },
  { label: "Agente de Carga", value: 8 },
  { label: "Contacto", value: 9 },
  { label: "Shipper", value: 10 },
  { label: "Agente Portuario", value: 11 },
  { label: "Agencia Aduanera", value: 12 },
  { label: "Agencia Maritima", value: 13 },
  { label: "Deposito Temporal", value: 14 },
  { label: "Deposito Vacio", value: 15 },
  { label: "Empleado", value: 16 },
  { label: "Terminal Portuario", value: 17 },
  { label: "Agente Reembolso", value: 18 },
  { label: "Coloader", value: 19 }
]

// USAR EN EL .5
export const COD_ROLES = {
  admin: '1',
  ger_log: '1050',
  coord_log: '1060',
  ejec_venta: '4',
  analg_costos: '1061',
  jef_vtas: '9',
  spr_vtas: '1031',
}

// USAR EN EL .31
// export const COD_ROLES = {
//     admin: '1',
//     ger_log: '2031',
//     coord_log: '2032',
//     ejec_venta: '4',
//     analg_costos: '2033',
//     jef_vtas: '9',
//     spr_vtas: '1029',
// }

export const CONST_VARIABLES = {
  CONSRGM_Importacion: "001",
  CCOT_OVDOCUMENTADA: "OVDOCUMENTADA",
  CCOT_OVSOLOLECTURA: "OVSOLOLECTURA",
  CCOT_OVEDITARCOSTO: "OVEDITARCOSTO",
  ENTC_ACCESOFINANZAS: "ACCFINANZAS",
  CCOT_VERCOSTOFCL: "VERCOSTOFCL",
  CONS_ESTCOTINGRESADA: "001",
  CONS_ESTCOTAUTORIZADA: "002",
  CONS_ESTCOTCONFIRMADA: "003",
  CONS_ESTCOTANULADA: "004",
  CONS_ESTOVEINGRESADA: "001",
  CONS_ESTOVECOORDINADA: "002",
  CONS_ESTOVECONFIRMADA: "003",
  CONS_ESTOVECONCLUIDA: "004",
  CONS_ESTOVEANULADA: "005",
  CONS_ESTOVEDOCUMENTADA: "006",
  CONS_ESTOVEPREFACTURADA: "007",
  CONS_ESTOVECERRADA: "008",
  CONS_SERIESLI: "SERIESLI",
  CONS_SERIECALLO: "SERIECALLO",
  TIPOTIP_PAI: "PAI",
  CODIGO_PAISPERU: "179",
  CCOT_OVCONCLUIDA: "OVCONCLUIDA",
  CCOT_EDITARCOTIZ: "EDITARCOTIZ",
  CCOT_ANULCOTIZ: "ANULCOTIZ",
  CCOT_APROCOTIZ4: "APROCOTIZ4",
  CONSRGM_Exportacion: "002",
  CONSLNG_Mandato: "001",
  CONSLNG_Exportacion: "002",
  CONSLNG_SLI: "003",
  CONSLNG_OtrosTraficos: "004",
  CONSVIA_Maritima: "001",
  CONSVIA_Aerea: "002",
  CONSVIA_Terrestre: "003",
  CONSVIA_Fluvial: "004",
  CONSFLE_LCL_LCL: "001",
  CONSFLE_LCL_FCL: "002",
  CONSFLE_FCL_FCL: "004",
  CONSFLE_FCL_LCL: "003",
  CONSBASFIJO: "001",
  CONSBASCONTENEDOR: "002",
  CONSBASTEUS: "003",
  CONSBASPESOVOLUMEN: "004",
  CCOT_TipoCotizacion: 1,
  CCOT_TipoOrdenVenta: 2,
  CCOT_APROCOTIZ1: "APROCOTIZ1",
  CCOT_APROCOTIZ2: "APROCOTIZ2",
  CCOT_APROCOTIZ3: "APROCOTIZ3",
}

export const PUERTOSWEB = {
  PRODUCCION: "10.0.2.4",
}
